module.exports = __webpack_public_path__ + "static/media/Underdark1.25b6c2b7.jpg";